import ProjectNavigationComponent from './project-navigation.component'

export default ProjectNavigationComponent
